import reusableComponents from './reusable-components'
import modals from './modals'

export default new Map([...reusableComponents, ...modals])
